(function () {
  'use strict';

  const root = document.documentElement;
  const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
  if (isDesignMode || !root.classList.contains('fty-page-transition')) return;

  let navigationTimer = null;

  function revealPage() {
    if (navigationTimer) {
      window.clearTimeout(navigationTimer);
      navigationTimer = null;
    }
    root.classList.remove('fty-page-leaving');
    window.requestAnimationFrame(function () {
      root.classList.add('fty-page-ready');
    });
  }

  revealPage();
  document.addEventListener('DOMContentLoaded', revealPage, { once: true });
  window.addEventListener('pageshow', revealPage);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') revealPage();
  });

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.target === '_blank') return;
    if (link.matches('[data-join-fty], [data-cookie-preferences-open], [data-fty-back], .cart-text')) return;

    const href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;

    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin) return;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;
    if (root.classList.contains('fty-page-leaving')) return;

    event.preventDefault();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.location.assign(url.href);
      return;
    }

    root.classList.remove('fty-page-ready');
    root.classList.add('fty-page-leaving');

    let hasNavigated = false;
    const navigate = function () {
      if (hasNavigated) return;
      hasNavigated = true;
      window.location.assign(url.href);
    };

    const duration = parseFloat(window.getComputedStyle(root).getPropertyValue('--fty-page-transition-duration')) * 1000;
    navigationTimer = window.setTimeout(navigate, (Number.isFinite(duration) ? duration : 150) + 100);
  });
})();
